import { useEffect, useState } from "react";
import { Checkbox, FormLabel, Grid, Skeleton, Stack, TextField, Typography, styled } from "@mui/material";
import { CalculatorSummary } from "../types";
import { CalculatorCard } from "../components";
import * as apiClient from "../api";
import AddCard from "../components/AddCard";
import CalculatorJsonDialog from "../components/CalculatorJsonDialog";

const LoadingCard = styled(Skeleton)({
  width: "22rem", // Three columns
  height: "8rem",
});

const Calculators = () => {
  const [loaded, setLoaded] = useState(false);
  const [calculators, setCalculators] = useState<CalculatorSummary[]>([]);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [displayAll, setDisplayAll] = useState(false);


  const loadCalculators = async () => {
    const res = await apiClient.getCalculators();
    setCalculators(res.data.calculators);
    setLoaded(true);
  };

  useEffect(() => {
    loadCalculators();
  }, []);

  const bySearch = ({ calculatorId, classification }: CalculatorSummary) => {
    const lowerSearch = search.toLowerCase();
    return search
      ? calculatorId.toLowerCase().includes(lowerSearch) ||
      classification.toLowerCase().includes(lowerSearch)
      : true;
  };

  const filteredCalculators = calculators.filter(bySearch);

  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h4">Calculators</Typography>
        <div>
          <FormLabel>Display Hidden</FormLabel>
          <Checkbox title="Display All" checked={displayAll} onChange={(e) => setDisplayAll(e.target.checked)} />
        </div>
        <TextField
          id="calculators-search"
          label="Search"
          variant="outlined"
          type="search"
          autoComplete="off"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <AddCard onClick={() => setOpen(true)} />
        <CalculatorJsonDialog open={open} handleClose={() => setOpen(false)} variant="add" onChange={() => { setLoaded(false); loadCalculators() }} />
      </Stack>
      <Grid container rowSpacing={2} columnSpacing={2}>
        {!loaded ? (
          <>
            <Grid item>
              <LoadingCard variant="rounded" />
            </Grid>
            <Grid item>
              <LoadingCard variant="rounded" />
            </Grid>
            <Grid item>
              <LoadingCard variant="rounded" />
            </Grid>
          </>
        ) : filteredCalculators.length === 0 ? (
          <Typography marginTop="4rem" width="100%" textAlign="center">
            No calculators found
          </Typography>
        ) : (
          filteredCalculators.filter((calculator) => {
            if (displayAll) {
              return true;
            }
            return calculator.display;
          }).map((calculatorSummary) => (
            <Grid key={calculatorSummary.calculatorId} item>
              <CalculatorCard calculatorSummary={calculatorSummary} />
            </Grid>
          ))
        )}
      </Grid>
    </Stack>
  );
};

export default Calculators;
